export class InvoiceResponse {
    functionHall: Array<FunctionJson>;
    pooja: Array<PoojaJson>;
    priest: Array<PriestAndServiceJson>;
    templeService: Array<PriestAndServiceJson>;
}
export class FunctionJson {
    address: string;
    bookFromToDate: string;
    devoteeName: string;
    email: string;
    hallAmount: number;
    invoiceNo: string;
    invoiceTotal: number;
    phone: string;
    productName: string;
    quantity: number;
    serviceDetails: Array<ServiceDetailJson>;
    transactionDate: string;
    transactionId: string;
}
export class PoojaJson {
    customerBookingDetails: Array<BookingDetail>;
    deityName: string;
    invoiceAmount: number;
    invoiceNo: string;
    productName: string;
    transactionDate: string;
    transactionId: string;
}
export class PriestAndServiceJson {
    address: string;
    amount: number;
    email: string;
    fromToDates: string;
    invoiceNo: string;
    location: string;
    name: string;
    phone: string;
    priestServiceId: number;
    productName: string;
    templeServiceDetailId: number;
    transactionDate: string;
    transactionId: string;
}
export class ServiceDetailJson {
    securityDeposit: number;
    serviceAmount: number;
    serviceName: string;
    serviceQuantity: number;
}
export class BookingDetail {
    address: string;
    amount: number;
    devoteeName: string;
    email: string;
    gothram: string;
    phone: string;
    poojaDate: string;
    quantity: number;
    star: string;
}
export class PaymentResponseObj {
    transactionType?: string;
    paymentDate?: string;
    paidAmount?: number;
    chequeNo?: string;
    voucherNo?: string;
    printType?: string;
    invoiceType?: string;
    invoiceNo?: string;
}
